<template>
  <el-dialog
    :title="$t('other.操作日志')"
    :visible.sync="dialogModal.visible"
    :close-on-click-modal="false"
    :before-close="formReset"
    top="5vh"
  >
    <div>
        <p class="mg-b-0">{{ $t("distributor.操作描述") }}</p>
        <hr class="mg-t-0">
        <div v-for="(item,index) of dialogModal.data" :key="index">
            {{item}}
            <hr class="mg-t-0">
        </div>
    </div>
    <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="formReset()">
            {{ $t("app.取消") }}
        </el-button>
    </div>
  </el-dialog>
</template> 
<script>
export default {
  name: "orderLog",
  props: {
    dialog: {
      type: Object,
      default: () => {
        return {
          visible: false,
          data: [],
        };
      },
    },
  },
  data() {
    return {
      dialogModal: this.dialog,
    };
  },
  watch: {
    dialog: {
      handler: function () { },
      immediate: true,
    },
  },
  methods: {
    // 重置表单
    formReset() {
      this.dialog.visible = false;
      this.dialog.data = [];
    },
  },
};
</script>
<style lang="less" scoped>
::v-deep .el-dialog__body {
  border: 1px solid #eee;
}
.scroll-box{
    height: 300px;
    overflow-y: auto;
}
</style>

